import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { CheckboxInputComponent } from '@fcom/ui-components/components/forms/checkbox-input/checkbox-input.component';
import { HeadingTagComponent } from '@fcom/ui-components/components/headers/heading-tag/heading-tag.component';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { LoaderComponent } from '@fcom/ui-components/components/loader/loader.component';
import { ModalComponent } from '@fcom/ui-components/components/modal/modal.component';

import { CmsModule } from '../../cms/components/cms.module';
import { ComponentsModule } from '../components/components.module';
import { PipesModule } from '../pipes/pipes.module';
import { MarketingPreferencesComponent } from './components/marketing-preferences.component';
import { MarketingPreferencesPageComponent } from './components/marketing-preferences-page.component';
import { ConsentService } from './services/consent.service';
import { DirectiveModule } from '../directives/directive.module';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    ComponentsModule,
    CmsModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    ButtonComponent,
    CheckboxInputComponent,
    HeadingTagComponent,
    IconComponent,
    LoaderComponent,
    ModalComponent,
    DirectiveModule,
  ],
  declarations: [MarketingPreferencesComponent, MarketingPreferencesPageComponent],
  exports: [MarketingPreferencesComponent, MarketingPreferencesPageComponent],
})
export class MarketingPreferencesModule {
  static forRoot(): ModuleWithProviders<MarketingPreferencesModule> {
    return {
      ngModule: MarketingPreferencesModule,
      providers: [ConsentService],
    };
  }
}
